//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/MechanicalRouting.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../Routing/Routing.RouteObjectCollector.js";
import "../no/Expression.js";
import "../no/Routing.js";
let d=[[[1,"Angle",0,"Expression",0],[0,"ApplicationMode",1,0],[0,"ApplySlopeToPath",1,0],[0,"FallDistance",1,0],[0,"LockFirst",1,0],[0,"LockLast",1,0],[0,"Orientation",1,0],[0,"Percentage",1,0],[0,"Ratio",1,0],[1,"SlopeCollector",0,"Routing.RouteObjectCollector",0],[0,"SlopeFallMethod",1,0]],[[[],"ReverseStartDirection",{},0,0],[[],"ComputeLegSequence",{},0,0],[[],"ComputeLegFall",{},0,0],[["legIndex","lock"],"SetLegPathFirstLock",{},2,0],[["legIndex","lock"],"SetLegPathLastLock",{},2,0],[[],"ValidatePathSelection",{R_:{errorSelection:''}},0,0],[["selectedTag","selectId","firstLock"],"IsLegLocked",{R_:{isLocked:''}},3,0],[["selectedTag","selectId"],"IsLegFullyLocked",{R_:{isFullyLocked:''}},2,0],[["selectedTag","selectId","firstLock"],"IsLegLockedBySystem",{R_:{isLockedBySystem:''}},3,0],[["selectedTag","selectId"],"IsLegFullyLockedBySystem",{R_:{isFullyLockedBySystem:''}},2,0]],[]];
SPLM.MechanicalRouting.SlopePathBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.MechanicalRouting.SlopePathBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.MechanicalRouting.SlopePathBuilder.SlopFallENUM = Object.freeze({
    "Angle" : "Angle", "Ratio1in" : "Ratio1in", "Percentage" : "Percentage"});

SPLM.MechanicalRouting.SlopePathBuilder.OrientationENUM = Object.freeze({
    "Up" : "Up", "Down" : "Down"});

SPLM.MechanicalRouting.SlopePathBuilder.ModeENUM = Object.freeze({
    "Forward" : "Forward", "Backward" : "Backward"});

export default SPLM;